import React from 'react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import TrimmedMarkdownRender from '@/components/text-editors/TrimmedMarkdownRender';
import PanelContainer from '@/components/wrappers/PanelContainer';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';

const DictionaryMarkdownPanelAll = ({ configuration, onChange, url }) => {
  const intl = useIntl();
  const {
    canRead, name, readStatus, readErrors, text,
  } = Selectors.useDictionaryMarkdownPanelAll(configuration);
  Fetch.useFetchDictionaryMarkdown(configuration, readStatus);

  return (
    <PanelContainer
      canAccess={canRead}
      entity="dictionary.read"
      exists
      name={readStatus === states.SUCCESS ? intl.formatMessage({ id: 'tabs.reader.of' }, { name }) : name}
      onChange={onChange}
      readErrors={readErrors}
      readStatus={[readStatus]}
      url={url}
    >
      <TrimmedMarkdownRender text={text} withMessage />
    </PanelContainer>
  );
};

export default DictionaryMarkdownPanelAll;
